import React from 'react';

const ErrorPage = () => {
    return (
        <div className='min-h-[60vh] px-5 md:px-20 lg:px-32 flex items-center justify-center gap-5'>
            <h1 className='text-4xl font-bold text-red-600'>404</h1>
            <p className='font-bold'>Page not found</p>
        </div>
    );
};

export default ErrorPage;